module.exports = __webpack_public_path__ + "static/media/line.c2807fbb.svg";